import { render, staticRenderFns } from "./SwitchTracking.vue?vue&type=template&id=1e3cba08"
import script from "./SwitchTracking.vue?vue&type=script&lang=js"
export * from "./SwitchTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports